export default __webpack_public_path__ + "static/media/018-cruise.c9c32112.svg";